import { FC } from 'react';
import styled from 'styled-components';

const TopBarElement = styled.header`
  display: flex;
  position: relative;
  align-items: center;
  border: 5px solid transparent;
  border-image-slice: 1;
  border-bottom: 0;
  border-right: 0;
  border-left: 0;
  height: 50px; /* 55px with 5px gradient border */
  box-sizing: content-box;
  padding-left: 10px; /* Don't have padding top or bottom to match MainNav height*/
  padding-right: 10px;
  z-index: 10;

  > div {
    flex: 1;
  }
`;

export const TopBar: FC = ({ children }) => <TopBarElement data-testid="TopBarElement">{children}</TopBarElement>;

export default TopBar;
